import { type FormHTMLAttributes } from "vue"
import { defineComponent, inferProps, renderSlot, type ReactiveComponent, type ValidationResult } from "vue-utils"
import BootstrapButton from "./BootstrapButton"
import Form from "./Form"
import FormButtons from "./FormButtons"

interface Props {
	onCancel: () => void
	cancelText?: string

	onSubmit: (e: Event) => void
	validate?: () => ValidationResult | Promise<ValidationResult>
	submitText?: string
}

const CancelSubmitForm: ReactiveComponent<Props, FormHTMLAttributes> = (props, { slots, attrs }) => {
	return () => (
		<Form class="flex flex-col" validate={props.validate} onSubmit={props.onSubmit} {...attrs}>
			{renderSlot(slots)}
			<hr class="w-full" />
			<FormButtons>
				<BootstrapButton type="button" color="secondary" onClick={props.onCancel}>
					{props.cancelText ?? "Cancel"}
				</BootstrapButton>
				<BootstrapButton type="submit" color="primary">
					{props.submitText ?? "Submit"}
				</BootstrapButton>
			</FormButtons>
		</Form>
	)
}

export default defineComponent(CancelSubmitForm, inferProps<Props>())
